import { render, staticRenderFns } from "./activityStatuses.vue?vue&type=template&id=4ba968f6"
import script from "./activityStatuses.vue?vue&type=script&lang=js"
export * from "./activityStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports